import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ReceivableCreate from '@app/views/Ledger/ReceivableCreate';
import { memo } from 'react';

export default memo(
  withIfUser(ReceivableCreate)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
